import { useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { IconImage, IconChevronDown } from '../atoms/Icon';

const EMOJI_GROUPS = [
  {
    label: 'Comidas',
    emojis: ['🍔', '🍕', '🌭', '🥪', '🍗', '🍖', '🥩', '🍟', '🌮', '🌯', '🥙', '🧆', '🥟', '🍢', '🍱', '🍣', '🍜', '🍝', '🍛', '🍚', '🍲', '🥘', '🍤', '🥗'],
  },
  {
    label: 'Doces',
    emojis: ['🍦', '🍨', '🍧', '🍰', '🎂', '🧁', '🍩', '🍪', '🥧', '🍫', '🍬', '🍭'],
  },
  {
    label: 'Bebidas',
    emojis: ['☕', '🍵', '🧋', '🥤', '🧃', '🍺', '🍷', '🥛', '🍹', '🧊'],
  },
];

function IconPicker({ value, onChange }) {
  const [show, setShow] = useState(false);

  return (
    <Dropdown show={show} onToggle={setShow}>
      <Dropdown.Toggle
        as="button"
        type="button"
        bsPrefix="icon-picker-toggle"
      >
        {value ? (
          <span style={{ fontSize: 20, lineHeight: 1 }}>{value}</span>
        ) : (
          <IconImage size={18} style={{ color: '#ccc' }} />
        )}
        <IconChevronDown size={12} className="icon-picker-chevron" />
      </Dropdown.Toggle>

      <Dropdown.Menu style={{ padding: 12, width: 288 }}>
        <div className="d-flex justify-content-between align-items-center mb-2 px-1">
          <span style={{ fontSize: 12, fontWeight: 600, color: '#888' }}>Escolha um ícone</span>
          {value && (
            <button
              type="button"
              className="action-btn action-btn-danger"
              style={{ fontSize: 11, padding: '2px 8px' }}
              onClick={() => { onChange(''); setShow(false); }}
            >
              Remover
            </button>
          )}
        </div>

        {EMOJI_GROUPS.map((group) => (
          <div key={group.label} className="mb-2 px-1">
            <div style={{ fontSize: 11, color: '#aaa', marginBottom: 4 }}>{group.label}</div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(8, 1fr)', gap: 2 }}>
              {group.emojis.map((emoji) => (
                <button
                  key={emoji}
                  type="button"
                  className={`icon-picker-option${emoji === value ? ' icon-picker-option-active' : ''}`}
                  onClick={() => { onChange(emoji); setShow(false); }}
                >
                  {emoji}
                </button>
              ))}
            </div>
          </div>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default IconPicker;
